module.exports = __webpack_public_path__ + "static/media/picture11@2x.8b494246.png";